<div class="modal-header">
  <div class="modal-header-x" (click)="closeModal()">
    <i-feather name="x"></i-feather>
  </div>
</div>
<transfer-nft [post]="post" [postHashHex]="postHashHex" (closeModal)="closeModalEvent($event)"></transfer-nft>
